import styles from '../index.module.css';
import React from 'react';

interface HighlightedProviderNameProps {
  name: string;
  substring: string;
}

const HighlightedProviderName: React.FC<HighlightedProviderNameProps> = (
  props,
) => {
  const { name, substring } = props;
  const startIndex = name.toLowerCase().indexOf(substring.toLowerCase());
  const endIndex = startIndex + substring.length;

  return (
    <div className={styles.ProviderName}>
      {name.substring(0, startIndex)}
      <span className={styles.HighlightedBoldSubstring}>
        {name.substring(startIndex, endIndex)}
      </span>
      {name.substring(endIndex, name.length)}
    </div>
  );
};

export default HighlightedProviderName;
